import { render } from "./SocialResponsibilitySection.vue?vue&type=template&id=56404e1a&scoped=true"
import script from "./SocialResponsibilitySection.vue?vue&type=script&lang=js"
export * from "./SocialResponsibilitySection.vue?vue&type=script&lang=js"

import "./SocialResponsibilitySection.vue?vue&type=style&index=0&id=56404e1a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56404e1a"]])

export default __exports__